if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"store","remotes":[{"alias":"zigzag-review","name":"zigzag-review","entry":"https://content.zigzag.kr/_review/latest/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(2(2366|5697|8611)|3(0150|1136|842)|42(20|86)3|6(0233|0866|3494|9538)|17454|77136|86626|94263|99794)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}